import { UcPackage } from '../types';
import api from './api-client'; 

// todo: upd review just in case
export const getAvailablePackages = async (): Promise<UcPackage[]> => {
  try {
    const response = await api.get('/payments/packs');
    
    if (!response.data || !Array.isArray(response.data)) {
      throw new Error('Invalid response format from server');
    }
    
    // Transform the backend data to match our frontend UcPackage type
    return response.data.map((pack: any) => {
      const mappedPack = {
        id: pack.id || String(Math.random()),
        amount: pack.ucAmount || 0,
        price: pack.price || 0,
        bonusPoints: pack.bonusPoints || 0,
        availableCodes: pack.availableCodes !== undefined ? pack.availableCodes : 10
      };
      return mappedPack;
    });
  } catch (error) {
    // Return empty array instead of throwing to prevent app crash
    return [];
  }
};
